export default "__VITE_ASSET__B8co3JO5__"